import React from 'react';

import ForgotPassword from '../pages/ForgotPassword/';

export const forgotPasswordRoutePage = {
  component: <ForgotPassword />,
  route: '/recuperar-senha',
  public: true,
};
